import React, { useState, useRef, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import { ContextApi } from "../../../App";
import { BranchesOutlined } from "@ant-design/icons";
import { Card,message } from "antd";
import PreviewApplicationView from "../../Candidate/ApplicationView/PreviewApplicationView";

function Radio({ onMoveDown, onMoveUp, onElementDelete, preset }) {
  const [options, setOptions] = useState([]);
  const [formbuilder, setFormBuilder] = useState([]);
  const contextData = useContext(ContextApi);
  const [modal, setModal] = useState(false);
  const [parentObj, setParentObj] = useState([]);
  const [child, setChild] = useState();
  const [childObj, setChildObj] = useState();
  const [selectParent, setSelectParent] = useState();
  const [modals, setModals] = useState(false);
  const [parentValue, setParentValue] = useState();
  const toggles = () => setModals(!modals);
  const [toggleComponent, setToggleComponent] = useState(false);
  const [toggleDeleteComponent, setToggleDeleteComponent] = useState(false);
    //CONDITIONAL DRAWER
    const [open, setOpen] = useState(false);
    const showDrawer = (id) => {
      setOpen(true);
    };
  
    const onClose = () => {
      setOpen(false);
    };
  let formBuilderElements = [
    ...document.querySelectorAll(".form-builder-element"),
  ];
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "radio",
    properties: {
      label: "Radio question field.",
      options: [],
      columns: 1,
    },
    parent: [],
    isChild: [],
    fillableByCandidate: true,
    fillableByHR: false,
    required: false,
    disableField: false,
  });



  useEffect(() => {
    let formBuilderElements = [
      ...document.querySelectorAll(".form-builder-element"),
    ];
    formBuilderElements = formBuilderElements.map((element) =>
      JSON.parse(element.getAttribute("data"))
    );

    const filterNull = formBuilderElements.filter((ele) => {
      return ele !== null;
    });
    const unique = filterNull.filter(
      (a, i) => filterNull.findIndex((s) => a.id === s.id) === i
    );
    setFormBuilder(unique);
  }, [options, element, open, selectParent, child, parentValue, modals]);

  useEffect(() => {
    let formBuilderElements = [
      ...document.querySelectorAll(".form-builder-element"),
    ];
    let s = formBuilderElements.map((element) =>
      JSON.parse(element.getAttribute("data"))
    );
    const filterNull = s.filter((ele) => {
      return ele !== null;
    });
    const unique = filterNull.filter(
      (a, i) => filterNull.findIndex((s) => a.id === s.id) === i
    );
    unique.forEach((ele) => {
      if (ele !== null && ele.type === "radio") {
        for (let i = 0; i < ele.parent.length; i++) {
          let newVal = unique.find(
            (item) => ele.parent[i]?.child?.id === item.id
          );
          ele.parent[i].child = newVal;
        }
      }
    });
    setFormBuilder(unique);
    const v = unique.find((e) => e.id === element.id);
    setElement({
      ...element,
      ...v,
    });
  }, [contextData.contextData.isEdit]);

  useEffect(() => {
    if (contextData.contextData.isDeletedArr.length !== 0) {
      let arr = [];

      for (let i = 0; i < element.parent.length; i++) {
        let flag = false;
        for (let j = 0; j < contextData.contextData.isDeletedArr.length; j++) {
          if (
            contextData.contextData.isDeletedArr[j]?.id ===
            element.parent[i].child?.id
          ) {
            flag = true;
          }
        }
        if (flag) {
          continue;
        } else {
          arr.push(element.parent[i]);
        }
      }
      setElement({
        ...element,
        parent: [...arr],
      });
      contextData.setContextData({
        ...contextData.contextData,
        isDeletedArr: [],
      });
    }
  }, [contextData.contextData.isDeletedArr]);

  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementAnswerRef = useRef();
  const elementRequiredRef = useRef();
  const disableFieldRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
      if (preset.properties) setOptions(preset.properties.options);
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);
  function onEdit() {
    setElement((previousState) => {
      previousState.properties.label = elementLabelRef.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      previousState.properties.options = options;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      previousState.disableField = disableFieldRef.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit: !contextData.contextData.isEdit,
    });
  }

  const alerts = (e) => {
    if (e === "success") {
      message.success("Changes Saved!,Successfully");
    } else if (e === "reset") {
      message.warning("Conditions Reset! Done");
    } else {
      message.warning("This Relation Already Exist");
    }
  };

  const handleSelectParent = (e) => {
    setToggleComponent(false);
    setSelectParent(e?.target?.value);
    const filterData = formbuilder?.filter((ele) => {
      return e?.target?.value === ele?.id;
    });
    setParentObj(filterData[0]);
  };

  const handleParentValue = (e) => {
    setParentValue(e.target.value);
    setToggleComponent(false);
  };

  function onAddNewAnswer(event) {
    if (elementAnswerRef.current.value !== "") {
      const isContained = options.some((element) => {
        return (
          element.replace(/  +/g, " ").trim().toLowerCase() ===
          elementAnswerRef.current.value
            .replace(/  +/g, " ")
            .trim()
            .toLowerCase()
        );
      });
      if (isContained) {
        swal({
          title: "Options already exist",
          icon: "warning",
        });
      }else{
        setOptions((state) => {
          state = [...state, elementAnswerRef.current.value];
          elementAnswerRef.current.value = "";
          return state;
        });
      }
    } else {
      swal("Input box should not be empty");
    }
  }

  function onDeleteOption(event) {
    const value = event.target.getAttribute("v");
    setOptions((state) => {
      let newState = [];
      for (let index = 0; index < state.length; index++) {
        const element = state[index];
        if (element !== value) {
          newState.push(element);
        }
      }
      return newState;
    });
  }

  function onChangeColumns(event) {
    const value = parseInt(event.target.value);
    setElement((previous) => {
      let state = { ...previous };
      state.properties.columns = value;
      return state;
    });
  }

  const handleSelectChild = (e) => {
    setToggleComponent(false);
    setChild(e.target.value);
    const filterData = formbuilder?.filter((ele) => {
      return e?.target?.value === ele?.id;
    });
    setChildObj(filterData[0]);
  };

  const checkDublicateReation = (obj1, obj2) => {
    if (obj1.pValue === obj2.pValue && obj1.child.id === obj2.child.id) {
      return true;
    } else {
      return false;
    }
    // return JSON.stringify(obj1) === JSON.stringify(obj2);
  };

  const reset = (e) => {
    e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "Once Reset, you will not be able to recover the Data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setElement({
          ...element,
          parent: [],
          isChild: [],
        });
        alerts("reset");
      } else {
        return;
      }
    });
  };

  const saveData = async (e) => {
    e.preventDefault();
    const parent = { pValue: parentValue, child: childObj };
    const foundDuplicate = formbuilder
      .filter((el) => el?.type === "radio" && el?.id === selectParent)
      .some((el) => el?.parent?.some((p) => checkDublicateReation(p, parent)));
    if (foundDuplicate) {
      alerts("warning");
      setSelectParent("");
      setParentValue("");
      setChild("");
    } else {
      formBuilderElements = formBuilderElements.map((element) =>
        JSON.parse(element.getAttribute("data"))
      );
      const element = formBuilderElements.find((el) => el?.id === selectParent);
      if (element) {
        setElement({
          ...element,
          parent: [...element.parent, parent],
          isChild: [...element.isChild, child],
        });
        alerts("success");
        setSelectParent("");
        setParentValue("");
        setChild("");
      }
    }
  };

  const delChildRelation = (e) => {
    e.preventDefault();
    const item = formbuilder.find(
      (item) => item?.type === "radio" && item?.id === selectParent
    );
    if (!item) return;
    setElement((prevState) => {
      const arr = item?.parent?.filter(
        (p) => !(p.pValue === parentValue && p.child.id === child)
      );
      const isChild = [...prevState.isChild.filter((ele) => ele !== child)];
      return {
        ...prevState,
        parent: [...arr],
        isChild,
      };
    });
    if (
      item?.parent.length ===
      item?.parent?.filter(
        (p) => !(p.pValue === parentValue && p.child.id === child)
      ).length
    ) {
      swal({
        title: "This Relation Doesn't Exist?",
        icon: "warning",
        dangerMode: true,
      });
    } else {
      swal({
        title: "Data deleted! Successfully",
        icon: "success",
        dangerMode: true,
      });
    }
    setSelectParent("");
    setParentValue("");
    setChild("");
  };

  return (
    <div
      className="form-group mb-3 form-builder-element"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e, element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        // onClick={() => showDrawer(element.id)}
        onClick={toggles}
      >
        <BranchesOutlined />
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>

      <label htmlFor="">
        {element.properties.label}
        {element.properties.required && <span style={{ color: "red" }}>*</span>}
      </label>

      <div className="row">
        {options.map((v, k) => (
          <div key={k} className={"col-md-" + 12 / element.properties.columns}>
            <div className="custom-control custom-radio">
              <input type="radio" className="custom-control-input" />
              <label className="custom-control-label">
                {k + 1}. {v}
              </label>
            </div>
          </div>
        ))}
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Radio Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Question</label>
            <input
              ref={elementLabelRef}
              defaultValue={element.properties.label}
              type="text"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Answers</label>
            {options.map((v, k) => (
              <div className="mb-3" key={k}>
                {k + 1}. {v}{" "}
                <button
                  className="btn btn-sm btn-danger float-right"
                  v={v}
                  onClick={onDeleteOption}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
          <div className="form-group">
            <div className="input-group">
              <input
                ref={elementAnswerRef}
                type="text"
                className="form-control"
              />
              <div className="input-group-append">
                <button className="btn btn-primary" onClick={onAddNewAnswer}>
                  Add
                </button>
              </div>
            </div>
          </div>
          <div className="form-group">
            <select
              name="columns"
              id="columns"
              className="form-control"
              defaultValue={element.properties.columns}
              onChange={onChangeColumns}
            >
              <option value="1">1 column (Single Lined)</option>
              <option value="2">2 columns</option>
              <option value="3">3 columns</option>
              <option value="4">4 columns</option>
            </select>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
          <div className="custom-control custom-checkbox formbuilder-hidden">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox formbuilder-hidden">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              ref={disableFieldRef}
              type="checkbox"
              className="custom-control-input"
              id="disableField"
              defaultChecked={element.disableField}
            />
            <label className="custom-control-label" htmlFor="disableField">
              Disable preFilled Field(only admin can edit)
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal size="lg" isOpen={modals} toggle={toggles}>
          <ModalHeader toggle={toggles}>
            {!toggleDeleteComponent ? (
              <div>
                <h3 style={{ textAlign: "center", marginLeft: "250px" }}>
                  Conditional Logic?
                </h3>
              </div>
            ) : (
              <div style={{ textAlign: "center", marginLeft: "250px" }}>
                <h3 style={{ textAlign: "center", margin: "0" }}>
                  Delete Relation!
                </h3>
                <span
                  style={{ textAlign: "center", margin: "0", color: "red" }}
                >
                  (Select Child you want to delete)
                </span>
              </div>
            )}
          </ModalHeader>
          <ModalBody>
            {toggleDeleteComponent ? (
              <div className="row shadow-sm ">
                <div className="col-md-3">
                  <select
                    className="mb-2 form-control "
                    value={selectParent}
                    onChange={handleSelectParent}
                    // disabled={true}
                  >
                    <option value="">Select Parent</option>;
                    {formbuilder &&
                      formbuilder
                        ?.filter((item) => {
                          return (
                            item?.type === "radio" && element.id === item?.id
                          );
                        })
                        .map((ele) => {
                          return (
                            <option value={ele?.id}>
                              {ele?.properties?.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    className="mb-2 form-control "
                    value={parentValue}
                    onChange={handleParentValue}
                    disabled={selectParent ? false : true}
                  >
                    <option value="">select Parent Value</option>;
                    {parentObj &&
                      parentObj.properties?.options?.map((ele) => {
                        return <option value={ele && ele}>{ele && ele}</option>;
                      })}
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    className="mb-2 form-control "
                    value={child}
                    onChange={handleSelectChild}
                    disabled={selectParent && parentValue ? false : true}
                  >
                    <option value="">select Child</option>;
                    {formbuilder &&
                      formbuilder
                        ?.filter((item) =>
                          item !== null
                            ? item.id !== selectParent &&
                              item.type !== "subheading" &&
                              item.properties.label !== "Name" &&
                              item.properties.label !== "Email" &&
                              item.properties.label !== "Phone Number"
                            : null
                        )
                        .map((ele) => {
                          return (
                            <option value={ele?.id}>
                              {ele?.properties?.label
                                ? ele?.properties?.label
                                : ele?.properties?.title}
                            </option>
                          );
                        })}
                  </select>
                </div>
                <div className="col-md-3">
                  <button
                    // style={{backgroundColor:"#717384"}}
                    // disabled={selectParent && parentValue && child ? false : true}
                    className="btn btn-danger  mr-1 btn-clipboard"
                    onClick={delChildRelation}
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                  <button
                    // style={{backgroundColor:"#717384"}}
                    // disabled={selectParent && parentValue && child ? false : true}
                    className="btn btn-secondary  mr-1 btn-clipboard"
                    onClick={() => {
                      setToggleDeleteComponent(false);
                      setParentValue("");
                      setChild("");
                      setSelectParent("");
                    }}
                  >
                    <i class="fa fa-arrow-circle-left" aria-hidden="true">
                      {" "}
                    </i>
                    Back
                  </button>
                </div>
              </div>
            ) : (
              <div className="row shadow-sm ">
                <div className="col-md-3">
                  <select
                    className="mb-2 form-control "
                    value={selectParent}
                    onChange={handleSelectParent}
                    // disabled={true}
                  >
                    <option value="">Select Parent</option>;
                    {formbuilder &&
                      formbuilder
                        ?.filter((item) => {
                          return (
                            item?.type === "radio" && element.id === item?.id
                          );
                        })
                        .map((ele) => {
                          return (
                            <option value={ele?.id}>
                              {ele?.properties?.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    className="mb-2 form-control "
                    value={parentValue}
                    onChange={handleParentValue}
                    disabled={selectParent ? false : true}
                  >
                    <option value="">select Parent Value</option>;
                    {parentObj &&
                      parentObj.properties?.options?.map((ele) => {
                        return <option value={ele && ele}>{ele && ele}</option>;
                      })}
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    className="mb-2 form-control "
                    value={child}
                    onChange={handleSelectChild}
                    disabled={selectParent && parentValue ? false : true}
                  >
                    <option value="">Select Child</option>;
                    {formbuilder &&
                      formbuilder
                        ?.filter((item) =>
                          item !== null
                            ? item.id !== selectParent &&
                              item.type !== "subheading" &&
                              item.properties.label !== "Name" &&
                              item.properties.label !== "Email" &&
                              item.properties.label !== "Phone Number"
                            : // item.type !== "multiSelect"
                              null
                        )
                        .map((ele) => {
                          return (
                            <option value={ele?.id}>
                              {ele?.properties?.label
                                ? ele?.properties?.label
                                : ele?.properties?.title}
                            </option>
                          );
                        })}
                  </select>
                </div>
                <div className="col-md-3">
                  <button
                    style={{ marginRight: "10px" }}
                    disabled={
                      selectParent && parentValue && child ? false : true
                    }
                    className="btn btn-primary  mr-2"
                    onClick={saveData}
                  >
                    <i class="fa fa-save"></i>
                  </button>

                  <button
                    // style={{backgroundColor:"#717384"}}
                    // disabled={selectParent && parentValue && child ? false : true}
                    className="btn btn-danger  mr-1 btn-clipboard"
                    onClick={() => {
                      setToggleDeleteComponent(true);
                      setParentValue("");
                      setChild("");
                      setSelectParent("");
                    }}
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                  <button
                    // style={{backgroundColor:"#717384"}}
                    // disabled={selectParent && parentValue && child ? false : true}
                    className="btn btn-secondary  mr-1 btn-clipboard"
                    onClick={reset}
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            )}

            <div
              style={{ marginTop: "40px" }}
              className="site-card-border-less-wrapper shadow-sm"
            >
              <Card
                // title={
                //   <div>
                //     <h3 style={{ textAlign: "center", margin: "0" }}>
                //       Form Preview
                //     </h3>
                //   </div>
                // }
                // bordered={false}
                // style={{
                //   marginTop: "2px",
                //   width: 900,
                // }}
                title="Form Preview"
                // bordered={false}
                className="border mt-4"
              >
                <PreviewApplicationView formPreviewData={formbuilder} />
              </Card>
            </div>
          </ModalBody>
        </Modal>
    </div>
  );
}

export default Radio;
